import _extends from "@babel/runtime/helpers/extends";
import React, { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import Loading from '../loading';
import { useSystem } from '../_helpers';
import { useCustomColor } from './hooks';

/**
 * 按钮用于开始一个即时操作。
 * @en Using for starting an immediate action
 * @type 通用
 * @type_en General
 * @name 按钮
 * @name_en Button
 */
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(false),
      isActive = _useState[0],
      setActive = _useState[1];

  var system = useSystem();
  var _props$type = props.type,
      type = _props$type === void 0 ? 'primary' : _props$type,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'semi' : _props$shape,
      _props$halfBorder = props.halfBorder,
      halfBorder = _props$halfBorder === void 0 ? false : _props$halfBorder,
      icon = props.icon,
      _props$showTextWhenLo = props.showTextWhenLoading,
      showTextWhenLoading = _props$showTextWhenLo === void 0 ? true : _props$showTextWhenLo,
      _props$needActive = props.needActive,
      needActive = _props$needActive === void 0 ? true : _props$needActive,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      color = props.color,
      bgColor = props.bgColor,
      borderColor = props.borderColor,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      loadingIcon = props.loadingIcon,
      onClick = props.onClick,
      onClickDisabled = props.onClickDisabled;
  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });

  var _useCustomColor = useCustomColor({
    color: color,
    bgColor: bgColor,
    borderColor: borderColor,
    isActive: isActive,
    disabled: disabled
  }),
      customColorClass = _useCustomColor.customColorClass,
      customColorStyle = _useCustomColor.customColorStyle;

  var handleTouchStart = function handleTouchStart() {
    if (needActive && !disabled && !loading) {
      setActive(true);
    }
  };

  var handleTouchEnd = function handleTouchEnd() {
    setActive(false);
  };

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      ref: domRef,
      style: _extends({}, customColorStyle, style),
      className: cls.apply(void 0, [prefixCls + "-button", className, "type-" + type, "size-" + size, "is-" + shape, system, {
        inline: inline,
        disabled: disabled,
        loading: loading,
        active: isActive,
        'half-border': halfBorder
      }].concat(customColorClass)),
      onTouchStart: handleTouchStart,
      onTouchEnd: handleTouchEnd,
      onTouchCancel: handleTouchEnd,
      onMouseDown: handleTouchStart,
      onMouseUp: handleTouchEnd,
      onClick: disabled ? onClickDisabled : onClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-icon"
    }, icon, loading && (loadingIcon === void 0 ? /*#__PURE__*/React.createElement(Loading, {
      className: "loading-icon",
      radius: 6,
      type: "circle"
    }) : loadingIcon)), (!loading || loading && showTextWhenLoading) && children ? /*#__PURE__*/React.createElement("div", {
      className: cls('btn-text', {
        'has-icon': loading || icon
      })
    }, children) : null);
  });
});
export default Button;